import { FC } from 'react';
// i18next
import { Trans, useTranslation } from 'react-i18next';
// MUI
import { Box, Card, Typography } from '@mui/material';
// Icons
import { HighlightOff as HighlightOffIcon } from '@mui/icons-material';
// Components
import Brand from 'app/components/Brand';

const AccountDeletionSuccessPage:FC = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      p: 4
    }}>
      <Brand />
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Card
          sx={{
            maxWidth: 'max-content',
            width: '100%',
            p: { xs: 3, md: 4 },
            boxShadow: 2,
            borderRadius: 3,
            border: '1px solid #f44336',
          }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
              <HighlightOffIcon color="error" sx={{ fontSize: { xs: 32, md: 40 } }} />
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 'bold',
                  color: 'error.main',
                  fontSize: { xs: 20, md: 24 },
                }}
              >
                {t('pages.accountDeletionSuccess.title')}
              </Typography>
            </Box>

            <Typography
              variant="body1"
              sx={{ mb: 2, fontSize: { xs: 16, sm: 18 }, lineHeight: 1.6 }}
            >
              <Trans
                i18nKey="pages.accountDeletionSuccess.message"
                components={{ b: <b /> }}
              />
            </Typography>
        </Card>
      </Box>
    </Box>
  );
};

export default AccountDeletionSuccessPage;
